import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { TooltipModule } from 'primeng/tooltip';
import { DoughnutChartComponent } from '../..';
import { TableApiQuery } from '../resource-table/resource-table-query-adapter.service';

@Component({
  selector: 'kon-dashboard-fragment',
  standalone: true,
  imports: [CommonModule, DoughnutChartComponent, TooltipModule, RouterModule],
  template: `<div
    class="border-gray-200 relative mb-4 xl:mb-0 flex flex-col h-full"
  >
    <i
      *ngIf="tooltip() as tooltip"
      class="pi pi-info-circle text-sm text-gray-600 absolute top-5 right-5 z-20"
      [pTooltip]="tooltip"
    ></i>
    <h4 class="w-full text-center py-4">
      {{ title() }}
    </h4>

    <kon-doughnut-chart
      *ngIf="chartData() as data; else elseBlock"
      [data]="data"
      [centerText]="centerText()"
      [chartOptions]="chartOptions()"
      class="flex-grow flex-shrink"
    />

    <ng-template #elseBlock>
      <div class="flex-grow text-lg relative">
        <p
          class="block absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
        >
          {{ centerText() }}
        </p>
        <p></p>
      </div>
    </ng-template>

    <a
      class="relative bottom-4 right-5 text-xs text-gray-500 place-self-end"
      [routerLink]="link()"
      [state]="routerState()"
    >
      Zobraziť
      <i class="pi pi-arrow-right text-xs"> </i>
    </a>
  </div>`,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardFragmentComponent {
  chartData = input<any>();
  centerText = input<number | string>(0);
  tooltip = input<string>();
  title = input<string>();
  chartOptions = input<any>({});
  link = input<string>();
  filters = input<string>();

  routerState = computed(() => ({
    query: {
      filters: this.filters(),
    } satisfies TableApiQuery,
  }));
}
